import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Payments and Transfers',
	subHeader: 'Make international payments quickly and securely online with Business Internet Banking.',
	listHeader: 'Make international payment',
	unAuthorisedMsg:
		'You don’t have permission to make payments and transfers. Please contact your corporate administrator for more information.',
	paymentsLimitMessage: 'You’ve now reached the maximum amount of Payees that you can process at the one time.',
	paymentTypeHelp:
		'Choose ‘One-off’ to move this money just once or ‘Repeating’ if you want to set up a standing order.',
	referenceHelp:
		"Add a brief description of what this payment or transfer's for. If you’re paying a company, enter the reference they’ve provided – this can usually be found on your bill or invoice. If you're transferring money between your own accounts, you can leave this blank.",
	invalidFormMsg:
		'We need some more information or some changes before you can continue. Please review your details and try again.',
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
	amountDescription: '',
	fromAccountDescription: '',
	toAccountDescription: '',
	paymentTypeDescription: '',
	referenceDescription: '',

	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reason for payment',
	dateLabel: 'Date',
	typeLabel: 'Type',
	addPayeeButtonTitle: 'Add new payee',
	noSearchResultMessage: 'No results',
	payeeSingularCountMessage:
		'Making more than one payment or transfer today? Save time and hassle by setting up to 150 transactions and processing them all at once.',
	copyToAllButton: 'Apply to all',
	addButton: 'Add another international payment',
	landingCreateTemplateButton: 'Create Payment Template',
	landingTemplateSectionHeader: 'Payment templates',
	paymentListInvalidMsg:
		'Some of your payment information hasn’t been completed. Please edit the highlighted row and complete all the required fields before you continue',
	indicativeRateMsg:
		'<IndicativeHighlight.description>*</IndicativeHighlight.description> The figures highlighted are subject to change until the payment is approved. The exact amounts will be clearly shown when it comes to authorising the payment.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
